module.exports = __webpack_public_path__ + "static/media/rewards-fr.e2b53561.jpg";